import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/AdorEquityTrafficSafetyHero-bg.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .aets { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .aets-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .aets-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .aets-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .aets-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .aets-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .aets-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .aets-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .aets-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .aets-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .aets-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .aets-bc-item:hover { color: #EB2019; }
  .aets-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .aets-bc-sep img { width: 24px; height: 24px; display: block; }
  .aets-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .aets-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .aets-main-section { padding: 80px 0 120px 0; }
  .aets-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .aets-article { flex: 1; min-width: 0; }

  .aets-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .aets-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .aets-meta-item:last-child { border-right: none; padding-right: 0; }
  .aets-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .aets-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  /* YouTube video embed */
  .aets-video-wrapper {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; overflow: hidden; border-radius: 10px;
    margin-bottom: 30px;
  }
  .aets-video-wrapper iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: 0;
  }

  .aets-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .aets-article-body p { margin-bottom: 20px; }
  .aets-article-body p:last-child { margin-bottom: 0; }

  .aets-article-body strong { font-weight: 600; color: #202020; }

  /* ══ BOTTOM ROW ══ */
  .aets-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .aets-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .aets-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .aets-nav-btn:hover { color: #EB2019; }
  .aets-nav-btn img { width: 40px; height: 40px; display: block; }

  .aets-share-icons { display: flex; align-items: center; gap: 20px; }
  .aets-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .aets-share-icon:hover { opacity: 0.85; }
  .aets-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .aets-sidebar { flex: 0 0 475px; }
  .aets-sidebar-block { margin-bottom: 60px; }
  .aets-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .aets-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .aets-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .aets-recent-item:hover .aets-recent-title { color: #EB2019; }
  .aets-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .aets-recent-body { flex: 1; min-width: 0; }
  .aets-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .aets-social-icons { display: flex; align-items: center; gap: 30px; }
  .aets-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .aets-social-icon:hover { opacity: 0.8; }
  .aets-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .aets-hero             { height: 350px; }
    .aets-hero-content     { padding: 0 32px; }
    .aets-hero-title       { font-size: 30px; }
    .aets-hero-divider     { width: 100%; max-width: 575px; }
    .aets-breadcrumb       { padding: 24px 0 0 0; }
    .aets-breadcrumb-inner { padding: 0 32px; }
    .aets-inner            { padding: 0 32px; }
    .aets-main-section     { padding: 48px 0 60px 0; }
    .aets-main-row         { flex-direction: column; gap: 48px; }
    .aets-sidebar          { flex: none; width: 100%; }
    .aets-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .aets-hero             { height: 360px; }
    .aets-hero-content     { padding: 0 16px; }
    .aets-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .aets-hero-divider     { width: 100%; }
    .aets-hero-subtitle    { font-size: 14px; }
    .aets-breadcrumb       { padding: 30px 0 0 0; }
    .aets-breadcrumb-inner { padding: 0 16px; }
    .aets-bc-item          { font-size: 14px; gap: 14px; }
    .aets-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .aets-bc-sep img       { width: 22px; height: 22px; }
    .aets-inner            { padding: 0 16px; }
    .aets-main-section     { padding: 30px 0 60px 0; }
    .aets-main-row         { flex-direction: column; gap: 60px; }
    .aets-sidebar          { flex: none; width: 100%; }
    .aets-article-title    { font-size: 20px; margin-bottom: 15px; }
    .aets-article-body     { font-size: 14px; }
    .aets-article-body p   { margin-bottom: 15px; }
    .aets-article-body strong { font-size: 16px; }
    .aets-meta-item        { font-size: 14px; }
    .aets-meta-item:nth-child(3) { border-right: none; padding-right: 0; }
    .aets-nav-btn img      { width: 24px; height: 24px; }
    .aets-nav-btn          { font-size: 14px; }
    .aets-share-icon img   { width: 34px; height: 34px; }
    .aets-sidebar-title    { font-size: 20px; }
    aets-video-wrapper  { margin-bottom: 20px; }
    .aets-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-guide/",
  },
];

export default function AdorEquityTrafficSafety() {
  return (
    <div className="aets">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="aets-hero">
        <img className="aets-hero-bg" src={HeroBgImg} alt="Ador makes a 51% equity investment in pioneering Australian Traffic Safety company Hero" />
        <div className="aets-hero-overlay" />
        <div className="aets-hero-content">
          <h1 className="aets-hero-title">
            Ador makes a 51% equity investment in pioneering Australian Traffic Safety company
          </h1>
          <hr className="aets-hero-divider" />
          <p className="aets-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="aets-breadcrumb" aria-label="Breadcrumb">
        <div className="aets-breadcrumb-inner">
          <a href="/" className="aets-bc-item">Home</a>
          <span className="aets-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="aets-bc-item">News &amp; Updates</a>
          <span className="aets-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="aets-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="aets-main-section">
        <div className="aets-inner">
          <div className="aets-main-row">

            {/* ── ARTICLE ── */}
            <article className="aets-article">

              {/* Meta bar */}
              <div className="aets-meta-bar">
                <span className="aets-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="aets-meta-item"><img src={CalendarIcon} alt="date" /> March 26, 2024</span>
                <span className="aets-meta-item"><img src={ClockIconImg} alt="time" /> 11:02 am</span>
                <span className="aets-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="aets-article-title">
                Ador makes a 51% equity investment in pioneering Australian Traffic Safety company
              </h1>

              {/* YouTube video embed */}
              <div className="aets-video-wrapper">
                <iframe
                  src="https://www.youtube.com/embed/IFl-F4yNh7Q?t=3s"
                  title="Ador makes a 51% equity investment in pioneering Australian Traffic Safety company"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>

              {/* Body */}
              <div className="aets-article-body">
                <p>The only one way to counter the increasing traffic fatalities around the world is to use intelligent technology</p>
              </div>

              {/* ── Bottom row — Next only ── */}
              <div className="aets-bottom-row">
                <div className="aets-bottom-nav">
                  <a href="acusensus-texting-driving" className="aets-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="aets-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/ador-makes-a-51-equity-investment-in-pioneering-australian-traffic-safety-company/" className="aets-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fador-makes-a-51-equity-investment-in-pioneering-australian-traffic-safety-company%2F&mode=login" className="aets-share-icon" aria-label="Twitter"  target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fador-makes-a-51-equity-investment-in-pioneering-australian-traffic-safety-company%2F%26title%3DAdor%2520invests%252051%2525%2520in%2520a%2520pioneering%2520Australian%2520safety%2520firm%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fador-makes-a-51-equity-investment-in-pioneering-australian-traffic-safety-company%2F" className="aets-share-icon" aria-label="LinkedIn"  target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="aets-sidebar">

              {/* Recent Posts */}
              <div className="aets-sidebar-block">
                <p className="aets-sidebar-title">Recent Posts</p>
                <div className="aets-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="aets-recent-item">
                      <img src={post.img} alt={post.title} className="aets-recent-img" />
                      <div className="aets-recent-body">
                        <span className="aets-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="aets-sidebar-block">
                <p className="aets-sidebar-title">Social Media</p>
                <div className="aets-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="aets-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="aets-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}